import $ from 'jquery';

let faqsEl = $('.faqs');

$(function () {
    if (faqsEl.length > 0) {
        bindToggleFaqs(faqsEl);
        faqsEl.each(function () {
            faqsList($(this));
        });
    }
});

const faqsList = faqsEl => {
    let filter = {
        lang: faqsEl.data('lang'),
        categories: faqsEl.data('categories'),
        sortAlphabetically: faqsEl.data('sort'),
        search: '',
        category: -1,
    };

    bindFaqFilter(faqsEl, filter);
};

const reRenderFaqs = async (element, filter) => {
    const data = await getFaqs(filter);
    element.find('.faqs__content').html(data.html);
    bindToggleFaqs(faqsEl);
};

function bindToggleFaqs(element) {
    // console.log(element.find('.faq__question'));
    element.find('.faq__question').on('click', function () {
        let faq = $(this).parent();
        let answer = faq.children().get(1);
        if ($(answer).is(':hidden')) {
            $(answer).slideDown(300, function () {
                $(answer).addClass('active');
            });
            faq.addClass('active');
        } else {
            $(answer).slideUp(300);
            $(answer).removeClass('active');
            faq.removeClass('active');
        }
    });
}

const bindFaqFilter = (element, filter) => {
    element.on('keyup', "input[name='faq-search']", function () {
        filter.search = $(this).val();
        reRenderFaqs(element, filter);
    });

    element.on('change', "select[name='faqs-categories']", function () {
        filter.category = $(this).val();
        reRenderFaqs(element, filter);
    });

    element.on('click', "button[name='remove-filter']", function () {
        filter.search = '';
        filter.category = -1;

        $(this).parent().parent().parent().find("select[name='faqs-categories']").val('-1');
        $(this).parent().parent().parent().find("input[name='faq-search']").val('');

        reRenderFaqs(element, filter);
    });
};

const getFaqs = async filter => {
    try {
        const response = await fetch(`/wp-json/nbs/v1/faq/html`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
